import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

/**
 * Empty stub for Alpine components.
 * 
 * @return {{}}
 */
function EmptyAlpineData() {
    return {};
}

/**
 * Accordion alpine.
 * 
 * @template T
 * @param {T} selected The default state of the accordion.
 * @return {{
 *      selected: T
 * }}
 */
function Accordion( selected = null ) { 
    return {
        selected: selected
    };
}

/**
 * Dictionary terms archive.
 * 
 * @return {{
 *      index:          Number,
 *      max:            Number,
 *      min:            Number,
 *      init:           Function,
 *      letterChanged:  Function
 * }}
 */
function DictionaryArchive() { 
    return {
        index: 0, max: 26, min: 0,

        init() { 
            this.$watch( 'index', this.letterChanged.bind( this ) );
        },
        
        letterChanged() {
            this.$dispatch( 'dictionary-letter-changed' );
        }
    };
}

/**
 * TrustPilot reviews component.
 * 
 * @return {{
 *      selected:   Number,
 *      open:       Function,
 *      close:      Function
 * }}
 */
function TrustPilot() { 
    return { 
        selected: 0, 
        
        open( index ) { 
            this.selected = index; 
            document.documentElement.style.overflow = 'hidden' 
        }, 
        
        close() { 
            this.selected = 0; 
            document.documentElement.style.overflow = 'auto' 
        } 
    };
}

/**
 * Mobile Menu component.
 * 
 * @return {{
 *      mobileMenuCollapsed:    Boolean,
 *      open:                   Function,
 *      close:                  Function
 * }}
 */
function MobileMenu() { 
    return { 
        mobileMenuCollapsed: false, 
        
        open() { 
            this.mobileMenuCollapsed = true; 
            document.documentElement.style.overflow = 'hidden' 
        }, 
        
        close() { 
            this.mobileMenuCollapsed = false; 
            document.documentElement.style.overflow = 'auto' 
        } 
    };
}

/**
 * The testimonials.
 * 
 * @return {{
 *      selected:   Number|String,
 *      open:       Function,
 *      close:      Function
 * }}
 */
function Testimonials() { 
    return { 
        selected: 0, 
        
        open( index ) { 
            this.selected = index; 
            document.documentElement.style.overflow = 'hidden' 

            setTimeout(() => {
                jQuery( `.modal-popup` ).addClass( "showvisually" )
            }, 150);
        }, 
        
        close() { 
            this.selected = 0; 
            document.documentElement.style.overflow = 'auto' 
            setTimeout(() => {
                jQuery( `.modal-popup` ).removeClass( "showvisually" )
            }, 150);
        } 
    };
}

/**
 * The table that shows information about cryptocurrencies, on cryptocurrencies.
 * 
 * @return {{
 *      dropped: any[]
 * }}
 */
function CryptocurrencyTable() {
    return { 
        dropped: [] 
    };
}

/**
 * Component for the search system.
 * 
 * @return {{
 *      search_showing: Boolean
 * }}
 */
function Search() { 
    return { 
        search_showing: false
    };
}

/**
 * Component for the "Read more" on the halal investing for beginners page.
 * 
 * @return {{
 *      selected:   Number,
 *      open:       Function,
 *      close:      Function
 * }}
 */
function HalalInvestingForBeginnersReadMore() { 
    return { 
        selected: 0, 
        
        open( index ) { 
            this.selected = index; 
            document.documentElement.style.overflow = 'hidden' 
        }, 
        
        close() { 
            this.selected = 0; 
            document.documentElement.style.overflow = 'auto' 
        } 
    };
}

/**
 * The inner for the content above.
 * 
 * @return {{
 *      isCollapsed:        Boolean,
 *      maxLength:          Number,
 *      originalContent:    String,
 *      content:            String,
 *      init:               Function
 * }}
 */
function HalalInvestingForBeginnersReadMore_Inner() { 
    return { 
        isCollapsed: false, 
        maxLength: 20, 
        originalContent: '', 
        content: '',

        init() { 
            this.originalContent = this.$refs.original.textContent.trim(); 
            this.splittedContent = this.originalContent.split(' ');
        }
    };
}

/**
 * The halal investments modal.
 * 
 * @returns {{
 *      show:           Boolean,
 *      modalElm:       String,
 *      toggleModal:    Function,
 *      closeModal:     Function
 * }}
 */
function HalalInvestmentsWhyInvest() {
    return { 
        show: false, 
        modalElm: "modal-popup",
        
        toggleModal() { 
            this.show = true; 
            document.documentElement.style.overflow = 'hidden' 
            
            setTimeout(() => {
                jQuery( `.${this.modalElm}` ).addClass( "showvisually" )
            }, 150);
        }, 
        
        closeModal() { 
            jQuery( `.${this.modalElm}` ).removeClass( "showvisually" )
            document.querySelector( `.${this.modalElm}` ).addEventListener( "transitionend", () => {
                document.documentElement.style.overflow = 'auto' 
                this.show = false;
            }, {
                capture: false,
                once: true,
                passive: false
            } )
        }
    };
}

/**
 * Modal for the How to calculate section under Zakat.
 * 
 * @returns {{
 *      show:           Boolean,
 *      modalElm:       String,
 *      toggleModal:    Function,
 *      closeModal:     Function
 * }}
 */
function ZakatHowToCalculate() {
    return { 
        show: false, 
        modalElm: "modal-popup",
        
        toggleModal() { 
            this.show = true; 
            document.documentElement.style.overflow = 'hidden' 
            
            setTimeout(() => {
                jQuery( `.${this.modalElm}` ).addClass( "showvisually" )
            }, 150);
        },
        
        closeModal() { 
            jQuery( `.${this.modalElm}` ).removeClass( "showvisually" )
            document.querySelector( `.${this.modalElm}` ).addEventListener( "transitionend", () => {
                document.documentElement.style.overflow = 'auto' 
                this.show = false;
            }, {
                capture: false,
                once: true,
                passive: false
            } )
        } 
    };
}

/**
 * The read more component for the bottom of an article, describing the person that wrote it.
 * 
 * @return {{
 *      isCollapsed:        Boolean,
 *      maxLength:          Number,
 *      originalContent:    String,
 *      content:            String,
 *      init:               Function
 * }}
 */
function ArticleSingleReadMore() {
    return { 
        isCollapsed:        false, 
        maxLength:          20, 
        originalContent:    '', 
        content:            '',

        init() { 
            this.originalContent    = this.$el.firstElementChild.textContent.trim(); 
            this.splittedContent    = this.originalContent.split( ' ' ); 
            this.content            = this.splittedContent.slice( 0, this.maxLength ).join( ' ' );
        }
    };
}

/**
 * The blog post categories filtration component.
 * 
 * @param {String[]} alreadySelected 
 * @returns {{
 *      showingCategories:          Boolean,
 *      showingOrder:               Boolean,
 *      selectedCategories:         String[],
 *      orderDirection:             String,
 *      init:                       Function,
 *      dispatchCategoriesChanged:  Function
 * }}
 */
function CategoriesFilter( alreadySelected = [] ) {
    return { 
        showingCategories: false, 
        showingOrder: false, 
        selectedCategories: alreadySelected, 
        orderDirection: '',

        init() {
            this.$watch( 'orderDirection', this.dispatchCategoriesChanged.bind( this ) ); 
            this.$watch( 'selectedCategories', this.dispatchCategoriesChanged.bind( this ) );      
        },

        dispatchCategoriesChanged() {
            return this.$dispatch( 'categories-changed' );
        }
    };
}

/**
 * The mobile submenu items.
 * 
 * @returns {{
 *      openedSubmenu: any
 * }}
 */
function MobileMenuSubmenu() {
    return {
        openedSubmenu: null
    }
}

/**
 * Blog single card, show more categories when there are more to show.
 * 
 * @returns {{
 *      showMoreCategories: Boolean
 * }}
 */
function BlogShowMoreCategories() {
    return { 
        showMoreCategories: false
    };
}

function Tabs( ID = '' ) { 
    return {
        ID: ID,
        selected: null,
        tabsValue : [],

        init() {
            const tabsParent    = document.getElementById(ID).querySelectorAll(".block-vl-tab-menu-item")

            this.tabsValue      = (Array.from(tabsParent).length) ? Array.from(tabsParent).map(tab => tab.innerText) : []
            this.selected       = this.tabsValue.length ? this.tabsValue[0] : null

            this.$watch("selected", value => value)
        }
    };
}

/**
 * Author featured in section, show more links when there are more than 3.
 * 
 * @returns {{
 *      showMore: Boolean
 * }}
 */
function AuthorShowMore() {
    return { 
        showMore: false
    };
}

function SignupPopup( el = "signup-popup" ) {
    return {
        popupEl: el,
        success: false,

        init() {
            window.signupPopupInstance = this.$el;

            if (!document.cookie.includes('signup_popup=true')) {
                document.getElementById(`${this.popupEl}`).style.display = "block";
            } else {
                document.getElementById(`${this.popupEl}`).style.display = "none";
            }

            this.showOnScroll()
        },

        onSubmitted() {
            this.success = true

            setTimeout(() => {
                this.close()
            }, 5000);
        },

        close() {
            document.cookie = "signup_popup=true; path=/; max-age=" + 60 * 60 * 24 * 30;
            document.getElementById(`${this.popupEl}`).style.cssText = "pointer-events:none;opacity:0;";
        },

        showOnScroll() {
            if (document.getElementById(`${this.popupEl}`) && !document.cookie.includes('signup_popup=true')) {
                ScrollTrigger.create({
                    trigger: document.documentElement,
                    start: `65% bottom`,
                    scrub: 1,
                    markers: false,
                    invalidateOnRefresh: true,
                    onEnter: () => {
                        document.getElementById(`${this.popupEl}`).style.cssText = "pointer-events:auto;opacity:1;";
                    }
                })
            }
        }
    }
}

/**
 * Initialises all of the components.
 */
export default async function initialiseAlpineComponents() { 
    /**
     * List of methods to expose to the window.
     * 
     * @var {Function[]}
     */
    const fnList = {
        "EmptyAlpineData": EmptyAlpineData, // Alias for `x-data="{}"`
        "Accordion": Accordion, 
        "DictionaryArchive": DictionaryArchive, 
        "TrustPilot": TrustPilot, 
        "MobileMenu": MobileMenu, 
        "Testimonials": Testimonials, 
        "CryptocurrencyTable": CryptocurrencyTable, 
        "Search": Search, 
        "HalalInvestingForBeginnersReadMore": HalalInvestingForBeginnersReadMore, 
        "HalalInvestingForBeginnersReadMore_Inner": HalalInvestingForBeginnersReadMore_Inner, 
        "HalalInvestmentsWhyInvest": HalalInvestmentsWhyInvest, 
        "ZakatHowToCalculate": ZakatHowToCalculate, 
        "ArticleSingleReadMore": ArticleSingleReadMore, 
        "CategoriesFilter": CategoriesFilter, 
        "MobileMenuSubmenu": MobileMenuSubmenu, 
        "BlogShowMoreCategories": BlogShowMoreCategories,
        "Tabs": Tabs,
        "AuthorShowMore": AuthorShowMore,
        "SignupPopup": SignupPopup
    };

    // Iterate on the list of methods and make them available to Alpine on load.
    Object.keys( fnList ).forEach( function ( k ) { 
        const d = fnList[ k ];
        window[ k ] = d;
    } );
}